var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st2{fill:#fff}\n    ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.141,
    y1: 965,
    x2: 29.859,
    y2: 965,
    gradientTransform: "translate(0 -950)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bd141b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#db1921"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.9,
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.123,
    y1: 965.164,
    x2: 29.877,
    y2: 965.164,
    gradientTransform: "translate(0 -950)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fdc700"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffbf31"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.8 7.5H2.2c-2.8 4.7-2.8 10.6 0 15.3h25.5c2.9-4.7 2.9-10.6.1-15.3z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15 .3C23.1.3 29.7 6.9 29.7 15S23.1 29.7 15 29.7.3 23.1.3 15 6.9.3 15 .3m0-.3C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.3 0 15 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 2.7S11 7.3 19.1 9s8.2 8.9 8.2 8.9c0-.3.2-.8.3-1.1.2-.8.4-1.8.4-2.7.1-2.9-.9-5.7-2.7-7.9-1.6-1.9-3.7-3.4-6.1-3.9-3.1-.7-6.3-.5-9.3.4z",
    style: {
      opacity: 0.2,
      fill: "#fff",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.819,
    y1: 20.293,
    x2: 11.925,
    y2: 20.293,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bd141b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#db1921"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.9 13.3c-.4-.5-1.1-1.4-1.1-1.4 0-.3 0-.4.2-.6.2-.2.5-.3.7-.3h.2c.2-.2.4-.3.8-.3.1 0 .3 0 .5.1v-.1s0-.1.1-.1l-.1-.1v-.2c0-.1.1-.2.2-.2h.2c.1 0 .2.1.2.2v.2s0 .1-.1.1l.1.1v.1h.3c.4 0 .7.2.8.3h.3c.4 0 .7.1.8.3.2.3 0 .7 0 .8l-1.1 1.2-3-.1z",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.5 10.1s.1.1 0 0l.1.3s0 .1-.1.1c0 0 .1 0 .1.1v.2c.1 0 .3-.1.4-.1.4 0 .7.3.8.3h.3c1.2 0 .8 1 .8 1l-1.1 1.2H8l-1.1-1.4c0-.7.5-.8.8-.8h.2c.2-.2.5-.3.7-.3.2 0 .4 0 .5.1v-.2s0-.1.1-.1c0 0-.1 0-.1-.1v-.2s0-.1.1-.1h.3m0-.1h-.2c-.2 0-.3.1-.3.2v.5h-.4c-.3 0-.6.1-.8.3h-.2c-.2 0-.5 0-.8.3-.1.2-.2.4-.2.6 0 0 .8 1 1.1 1.4H10.5l1.1-1.2s.2-.5 0-.8c-.1-.2-.4-.4-.9-.4h-.2c-.1-.1-.4-.3-.8-.3h-.3v-.4c.3-.1.2-.2.1-.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.725,
    y1: 15.875,
    x2: 14.051,
    y2: 15.875,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bd141b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#db1921"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.5c-.2 0-.3-.1-.3-.3v-.3c0-.1.1-.2.2-.3v-.2c0-.1.1-.2.2-.2v-1.5c-.3-.1-.4-.3-.4-.5 0 0 0-.2.1-.3.1-.1.1-.1.3-.1v-.2h-.7v2.3s.1.4-.2.8c-.4.5-1.1.7-2.3.7-1.1 0-1.9-.2-2.2-.7-.3-.4-.2-.9-.2-.9V16c-.1-.2-.3-.6-.5-.6h-.2v.3c.2.1.4.3.4.5 0 .3-.2.4-.4.5v1.5c.1 0 .2.1.2.2v.2c.1 0 .2.2.2.3v.3c0 .2-.1.3-.3.3H5.2c-.2 0-.3-.1-.3-.3v-.3c0-.1.1-.2.2-.3v-.2c0-.1.1-.2.2-.2v-1.1c-.1.1-.2.2-.2.3l-.1.1v-.1s-.2-.6.4-.9v-.4c-.4 0-.6-.1-.7-.5v-.1c0-.1.2-.2.5-.2v-1.1c-.1-.1-.2-.2-.2-.3v-.2c0-.1.1-.2.2-.2h.1-.4l.8-.7.8.7h-.3c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2v1h.7v-1.6h4.9v1.6h.7v-1c-.1 0-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2h.1-.4l.8-.7.8.7h-.3c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2v1.1c.2.1.4.2.4.3v.3c0 .1-.2.3-.4.4v.5c.3.1.4.2.4.4v.2c0 .2-.2.3-.3.3v.7c.1 0 .2.1.2.2v.2c.1 0 .2.2.2.3v.3c0 .2-.1.3-.3.3l-1.2-.1zm1.1-2c.1-.2.1-.3 0-.4v.4z",
    style: {
      fill: "url(#SVGID_4_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m13.1 12.9.6.6h-.2v.1h.1c.1 0 .1.1.1.1v.2c0 .1-.1.1-.1.1v1.2c.3.1.6.2.4.5 0 0-.2.4-.4.4v.6c.2 0 .4.1.4.4 0 0 0 .4-.3.4 0 0 .3-.5-.1-.6v1.4c.1 0 .1.1.1.1v.2c.1 0 .2.1.2.2v.3c0 .1-.1.2-.2.2h-1.1c-.1 0-.2-.1-.2-.2v-.3c0-.1.1-.2.2-.2v-.2c0-.1.1-.1.1-.1v-1.6c-.1 0-.4-.2-.4-.4 0 0-.1-.4.3-.4v-.4h-.8V18s.4 1.5-2.4 1.5S7 17.9 7 17.9v-1.8c-.1-.3-.3-.7-.6-.7-.1 0-.1 0-.2.1v.4c.2 0 .4.2.4.5s-.2.4-.4.4v1.6c.1 0 .1.1.1.1v.2c.1 0 .2.1.2.2v.3c0 .1-.1.2-.2.2H5.2c-.1 0-.2-.1-.2-.2v-.3c0-.1.1-.2.2-.2v-.2c0-.1.1-.1.1-.1V17c-.1.1-.3.2-.4.4 0 0-.2-.6.4-.9v-.4c-.2 0-.5-.2-.5-.5 0 0 0-.3.5-.3V14c-.1 0-.1-.1-.1-.1v-.2c0-.1.1-.1.1-.1h.2v-.1h-.3l.7-.6.6.6h-.2v.1h.1c.1 0 .1.1.1.1v.2c0 .1-.1.1-.1.1v1.1h.8v-1.6H12v1.6h.8V14c-.1 0-.1-.1-.1-.1v-.2c0-.1.1-.1.1-.1h.2v-.1h-.4l.5-.6m0-.2-.8.7-.2.2h.2V13.9c0 .1.1.2.2.2v.9h-.6v-1.6H6.9V15h-.6v-.9c.1 0 .2-.1.2-.2V13.6h.2l-.2-.2-.6-.6-.1-.1-.1.1-.7.6-.2.2H5V13.9c0 .1 0 .2.2.2v1c-.3 0-.4.2-.5.3v.2c0 .3.2.5.5.6v.3c-.5.3-.4.8-.3 1l.1.3v-.3c0-.1.1-.1.1-.2v.9c-.1.1-.1.2-.1.3v.1c-.1.1-.2.2-.2.3v.3c0 .2.2.4.4.4h1.1c.2 0 .4-.2.4-.4v-.3c0-.1-.1-.2-.2-.3v-.1c0-.1-.1-.2-.2-.2v-1.4c.1 0 .3-.2.4-.5 0-.3-.1-.5-.4-.6v-.2h.1c.2 0 .4.3.5.6V18c0 .1-.1.5.2.9.4.5 1.1.8 2.3.8 1.2 0 1.9-.3 2.3-.7.3-.4.2-.8.2-.9v-2.2h.6v.1c-.1 0-.2 0-.2.1-.1.1-.1.3-.1.3 0 .2.1.4.4.5v1.5c-.1 0-.2.1-.2.2v.1c-.1.1-.2.2-.2.3v.3c0 .2.2.4.4.4h1.1c.2 0 .4-.2.4-.4V19c0-.1-.1-.2-.2-.3v-.1c0-.1-.1-.2-.2-.2v-.6c.2 0 .3-.2.4-.4v-.2c0-.2-.1-.4-.4-.5v-.4c.2-.1.4-.3.4-.4v-.4c-.1-.1-.2-.2-.4-.3v-1c.1 0 .2-.1.2-.2V13.7h.2l-.2-.3-.8-.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsEs);
export default __webpack_public_path__ + "static/media/es_es.536f7c3bd49dd0e850f9b7cff651e100.svg";
export { ForwardRef as ReactComponent };